import { Action } from '../../../common/actions/core/action';

export class OpenDoubleOptErrorDialogAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/error/double-opt-error-dialog.action.ts